export default __webpack_public_path__ + "static/media/chaqueta-militar-hombre.890440a5.png";